// ============================================================
//  Grupo RPC — Content & Translations (ES / EN)
//  NOTE: This is MOCK/placeholder content for the frontend.
//  Images are professional stock placeholders — replace with
//  the company's real photos when available.
// ============================================================

export const images = {
  // Real Grupo RPC photos (enhanced + confidential info blurred)
  controlRoom2: "/images/operadora.jpg",       // real operator (monitoring + marquee)
  guardStanding: "/images/guardia-acceso.jpg", // real guard (services + marquee)
  guardEntrance: "/images/guardia-acceso.jpg", // real guard (marquee)
  // Stock placeholders (hero + access control + cleaning)
  heroControlRoom: "https://images.unsplash.com/photo-1708807472445-d33589e6b090",
  guardVest: "https://images.unsplash.com/photo-1652739758426-56a564265f9e",
  cctv1: "https://images.unsplash.com/photo-1549109926-58f039549485",
  cctv2: "https://images.unsplash.com/photo-1589935447067-5531094415d1",
  cctv3: "https://images.unsplash.com/photo-1528312635006-8ea0bc49ec63",
  cleaning1: "https://images.unsplash.com/photo-1669101602108-fa5ba89507ee",
  cleaning2: "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce",
  warehouse1: "https://images.unsplash.com/photo-1771530789155-b1f03fbf82b5",
  warehouse2: "https://images.unsplash.com/photo-1758789667762-56175fe4601c",
  handshake1: "https://images.unsplash.com/photo-1638262052640-82e94d64664a",
  handshake2: "https://images.unsplash.com/photo-1521791136064-7986c2920216",
  cleaningEquip: "https://images.unsplash.com/photo-1580256081112-e49377338b7f",
};

export const contactInfo = {
  email: "contacto@serviciorpc.cl",
  phone: "+56 9 6877 4063",
  phoneRaw: "56968774063",
  whatsapp: "https://wa.me/56968774063",
  location: "Santiago, Chile",
};

// Gallery strip (marquee) — uses the company's real photos + CCTV camera
const galleryES = [
  { img: images.guardStanding, label: "Guardias en terreno" },
  { img: images.controlRoom2, label: "Central de monitoreo" },
  { img: images.cctv2, label: "Cámaras CCTV" },
  { img: images.cctv1, label: "Rondas y patrullaje" },
];
const galleryEN = [
  { img: images.guardStanding, label: "On-site guards" },
  { img: images.controlRoom2, label: "Monitoring center" },
  { img: images.cctv2, label: "CCTV cameras" },
  { img: images.cctv1, label: "Patrols & rounds" },
];

export const content = {
  es: {
    nav: {
      links: [
        { label: "Servicios", href: "#servicios" },
        { label: "Empresas", href: "#empresas" },
        { label: "Aseo", href: "#aseo" },
        { label: "Monitoreo", href: "#monitoreo" },
        { label: "Preguntas", href: "#faq" },
      ],
      cta: "Cotiza gratis",
      langLabel: "EN",
    },
    hero: {
      badge: "Protección 24/7 en tiempo real",
      titleTop: "Seguridad que nunca deja de",
      titleAccent: "observar.",
      subtitle:
        "Guardias acreditados OS-10, control de acceso, cámaras CCTV y una central de monitoreo 24/7 — más aseo industrial con personal, equipos e insumos incluidos. Todo con un solo proveedor en Chile.",
      ctaPrimary: "Solicita tu cotización",
      ctaSecondary: "Ver servicios",
      stats: [
        { value: "24/7", label: "Cámaras vigiladas" },
        { value: "Alertas", label: "Detección de movimiento" },
        { value: "3", label: "Empresas especializadas" },
      ],
    },
    trust: {
      items: [
        {
          title: "Personal acreditado OS-10",
          text: "Guardias con credencial vigente y capacitación continua avalada por la autoridad.",
        },
        {
          title: "Cobertura integral",
          text: "Seguridad física, tecnología de vigilancia y aseo industrial en un único contrato.",
        },
        {
          title: "Respuesta inmediata",
          text: "Protocolos de aviso y reacción activados en segundos ante cualquier evento.",
        },
      ],
      gallery: galleryES,
    },
    services: {
      eyebrow: "Servicios de seguridad",
      title: "Protección en terreno y a distancia",
      subtitle:
        "Personal capacitado, tecnología de vigilancia y supervisión permanente para proteger sus instalaciones, colaboradores y activos.",
      items: [
        {
          tag: "Guardias",
          title: "Guardias de seguridad",
          img: images.guardStanding,
          text: "Personal de vigilancia diurno y nocturno, acreditado, uniformado y supervisado en terreno.",
          points: ["Guardias diurnos y nocturnos", "Supervisión permanente", "Personal acreditado OS-10"],
        },
        {
          tag: "Accesos",
          title: "Control de acceso",
          img: images.guardVest,
          text: "Gestión de entradas y salidas, registro de visitas y proveedores en sus instalaciones.",
          points: ["Control de personas y vehículos", "Registro digital de visitas", "Porterías para distintos sitios"],
        },
        {
          tag: "Rondas · CCTV",
          title: "Rondas y cámaras",
          img: images.cctv2,
          text: "Patrullaje, rondas de seguridad e instalación de sistemas CCTV conectados a nuestra central.",
          points: ["Proyecto e instalación de cámaras", "Conexión a central de monitoreo", "Mantención de equipos"],
        },
      ],
    },
    companies: {
      eyebrow: "Nuestras empresas",
      title: "Tres marcas, un mismo estándar",
      subtitle:
        "Tres empresas especializadas bajo un mismo grupo, enfocadas en seguridad, tecnología y limpieza industrial.",
      items: [
        {
          name: "RPC Seguridad",
          initials: "RPC",
          text: "Guardias de seguridad y vigilancia privada para instalaciones industriales, comerciales y residenciales. Personal capacitado con presencia permanente en terreno.",
        },
        {
          name: "RPC Limpieza Industrial",
          initials: "RPC",
          text: "Limpieza y aseo industrial con dotación de personal, maquinaria, equipos e insumos incluidos. Su instalación siempre limpia y operativa.",
        },
        {
          name: "Serviram Seguridad",
          initials: "SVR",
          text: "Soluciones tecnológicas: cámaras de vigilancia, control de acceso y conexión a nuestra central de monitoreo 24/7.",
        },
      ],
    },
    aseo: {
      eyebrow: "RPC Limpieza Industrial",
      title: "Aseo industrial, todo incluido",
      subtitle:
        "Entregamos el servicio completo: las personas, las máquinas y los materiales. Usted solo recibe una instalación limpia y operativa.",
      img: images.cleaning1,
      items: [
        {
          title: "Personal de aseo",
          text: "Dotación de auxiliares capacitados, uniformados y supervisados para plantas, oficinas, bodegas y faenas.",
        },
        {
          title: "Maquinaria y equipos",
          text: "Equipamiento de limpieza industrial incluido: máquinas, herramientas y elementos de protección personal.",
        },
        {
          title: "Materiales e insumos",
          text: "Provisión permanente de materiales de limpieza e insumos para mantener la operación sin interrupciones.",
        },
      ],
    },
    monitoring: {
      eyebrow: "Central de monitoreo",
      title: "Cámaras vigiladas 24/7 con detección de movimiento y reportes inmediatos",
      subtitle:
        "Supervisores dedicados observan en tiempo real las cámaras instaladas en los recintos de nuestros clientes.",
      live: "EN VIVO",
      img: images.controlRoom2,
      stats: [
        { value: "24/7", label: "Cámaras vigiladas" },
        { value: "Alertas", label: "Detección de movimiento" },
        { value: "365", label: "Días al año" },
        { value: "100%", label: "Supervisión humana" },
      ],
      footer:
        "Ante cualquier evento, se activan de inmediato los protocolos de respuesta y aviso. Nuestra central opera 24 horas, 7 días de la semana, los 365 días del año.",
    },
    sectors: {
      eyebrow: "Sectores que protegemos",
      title: "Soluciones a la medida de su industria",
      items: [
        "Industria y manufactura",
        "Bodegas y logística",
        "Retail y centros comerciales",
        "Oficinas corporativas",
        "Faenas y construcción",
      ],
    },
    testimonials: {
      eyebrow: "Lo que dicen nuestros clientes",
      title: "Confianza que se construye turno a turno",
      items: [
        {
          quote:
            "La central de monitoreo detectó un intento de intrusión de madrugada y actuaron en segundos. Cero pérdidas. Un servicio impecable.",
          name: "Jefe de Operaciones",
          role: "Empresa de logística, Santiago",
        },
        {
          quote:
            "Tener seguridad y aseo industrial con un solo proveedor nos simplificó todo. Personal serio, uniformado y siempre supervisado.",
          name: "Gerente de Planta",
          role: "Industria manufacturera",
        },
        {
          quote:
            "Los guardias son acreditados y la supervisión se nota. Nos dan reportes claros y respuesta inmediata ante cualquier evento.",
          name: "Administrador",
          role: "Automotora",
        },
      ],
    },
    faq: {
      eyebrow: "Preguntas frecuentes",
      title: "Resolvemos sus dudas",
      items: [
        {
          q: "¿Sus guardias están acreditados OS-10?",
          a: "Sí. Todo nuestro personal de vigilancia cuenta con credencial OS-10 vigente y recibe capacitación continua conforme a la normativa chilena.",
        },
        {
          q: "¿Atienden empresas en todo Chile?",
          a: "Operamos principalmente en la Región Metropolitana y coordinamos servicios en otras regiones según el proyecto. Consúltenos por su ubicación.",
        },
        {
          q: "¿Puedo contratar seguridad y aseo industrial juntos?",
          a: "Sí. Somos un grupo con tres empresas especializadas, por lo que puede contratar seguridad, tecnología de monitoreo y aseo industrial en un solo contrato integrado.",
        },
        {
          q: "¿La central de monitoreo opera realmente 24/7?",
          a: "Sí. Supervisores humanos vigilan las cámaras las 24 horas, los 7 días de la semana, los 365 días del año, con detección de movimiento, reportes inmediatos y protocolos de respuesta inmediata.",
        },
        {
          q: "¿Cómo solicito una cotización?",
          a: "Complete el formulario de contacto, escríbanos por WhatsApp o llámenos. Le enviaremos una propuesta a la medida de su empresa sin costo.",
        },
      ],
    },
    contact: {
      eyebrow: "Contacto",
      title: "Cotice hoy su servicio",
      subtitle: "Cuéntenos qué necesita proteger o mantener limpio",
      text: "Le enviaremos una propuesta a la medida de su empresa. Puede escribirnos por correo, WhatsApp o llamarnos directamente.",
      formTitle: "Envíenos un mensaje",
      fields: { name: "Nombre", phone: "Teléfono", email: "Correo", message: "Mensaje" },
      placeholders: {
        name: "Su nombre",
        phone: "+56 9 ...",
        email: "correo@empresa.cl",
        message: "Cuéntenos qué servicio necesita...",
      },
      submit: "Enviar solicitud",
      sending: "Enviando...",
      success: "¡Gracias! Su solicitud fue enviada. Le contactaremos a la brevedad.",
      error: "Ocurrió un error. Intente nuevamente o escríbanos por WhatsApp.",
      validation: "Por favor complete al menos su nombre y correo.",
      contactLabels: { email: "Correo", whatsapp: "WhatsApp", phone: "Teléfono" },
    },
    footer: {
      tagline: "Seguridad, monitoreo y aseo industrial para empresas en Chile.",
      servicesTitle: "Servicios",
      services: ["Guardias de seguridad", "Control de acceso", "Cámaras CCTV", "Central de monitoreo 24/7", "Aseo industrial"],
      companyTitle: "Grupo RPC",
      links: ["Servicios", "Empresas", "Aseo industrial", "Monitoreo", "Contacto"],
      contactTitle: "Contacto",
      rights: "Todos los derechos reservados.",
    },
    whatsapp: "¿Necesita seguridad? Escríbanos",
  },

  en: {
    nav: {
      links: [
        { label: "Services", href: "#servicios" },
        { label: "Companies", href: "#empresas" },
        { label: "Cleaning", href: "#aseo" },
        { label: "Monitoring", href: "#monitoreo" },
        { label: "FAQ", href: "#faq" },
      ],
      cta: "Free quote",
      langLabel: "ES",
    },
    hero: {
      badge: "Real-time 24/7 protection",
      titleTop: "Security that never stops",
      titleAccent: "watching.",
      subtitle:
        "OS-10 accredited guards, access control, CCTV cameras and a 24/7 monitoring center — plus industrial cleaning with staff, equipment and supplies included. All from a single provider in Chile.",
      ctaPrimary: "Request a quote",
      ctaSecondary: "See services",
      stats: [
        { value: "24/7", label: "Cameras watched" },
        { value: "Alerts", label: "Motion detection" },
        { value: "3", label: "Specialized companies" },
      ],
    },
    trust: {
      items: [
        {
          title: "OS-10 accredited staff",
          text: "Guards with valid credentials and continuous training endorsed by the authority.",
        },
        {
          title: "End-to-end coverage",
          text: "Physical security, surveillance technology and industrial cleaning in a single contract.",
        },
        {
          title: "Immediate response",
          text: "Alert and reaction protocols triggered within seconds of any event.",
        },
      ],
      gallery: galleryEN,
    },
    services: {
      eyebrow: "Security services",
      title: "Protection on-site and remote",
      subtitle:
        "Trained personnel, surveillance technology and permanent supervision to protect your facilities, people and assets.",
      items: [
        {
          tag: "Guards",
          title: "Security guards",
          img: images.guardStanding,
          text: "Day and night surveillance personnel, accredited, uniformed and supervised on-site.",
          points: ["Day & night guards", "Permanent supervision", "OS-10 accredited staff"],
        },
        {
          tag: "Access",
          title: "Access control",
          img: images.guardVest,
          text: "Management of entries and exits, visitor and supplier registration at your facilities.",
          points: ["People & vehicle control", "Digital visitor log", "Gatehouses for multiple sites"],
        },
        {
          tag: "Patrol · CCTV",
          title: "Patrols & cameras",
          img: images.cctv2,
          text: "Patrols, security rounds and CCTV installation connected to our monitoring center.",
          points: ["Camera design & install", "Monitoring center link", "Equipment maintenance"],
        },
      ],
    },
    companies: {
      eyebrow: "Our companies",
      title: "Three brands, one standard",
      subtitle:
        "Three specialized companies under one group, focused on security, technology and industrial cleaning.",
      items: [
        {
          name: "RPC Seguridad",
          initials: "RPC",
          text: "Security guards and private surveillance for industrial, commercial and residential facilities. Trained personnel with a permanent on-site presence.",
        },
        {
          name: "RPC Limpieza Industrial",
          initials: "RPC",
          text: "Industrial cleaning with staff, machinery, equipment and supplies included. Your facility always clean and operational.",
        },
        {
          name: "Serviram Seguridad",
          initials: "SVR",
          text: "Technology solutions: surveillance cameras, access control and connection to our 24/7 monitoring center.",
        },
      ],
    },
    aseo: {
      eyebrow: "RPC Limpieza Industrial",
      title: "Industrial cleaning, all included",
      subtitle:
        "We deliver the complete service: the people, the machines and the materials. You simply get a clean, operational facility.",
      img: images.cleaning1,
      items: [
        {
          title: "Cleaning staff",
          text: "Trained, uniformed and supervised cleaning assistants for plants, offices, warehouses and sites.",
        },
        {
          title: "Machinery & equipment",
          text: "Industrial cleaning equipment included: machines, tools and personal protective equipment.",
        },
        {
          title: "Materials & supplies",
          text: "Permanent supply of cleaning materials to keep operations running without interruptions.",
        },
      ],
    },
    monitoring: {
      eyebrow: "Monitoring center",
      title: "Cameras watched 24/7 with motion detection and instant reports",
      subtitle:
        "Dedicated supervisors watch, in real time, the cameras installed at our clients' premises.",
      live: "LIVE",
      img: images.controlRoom2,
      stats: [
        { value: "24/7", label: "Cameras watched" },
        { value: "Alerts", label: "Motion detection" },
        { value: "365", label: "Days a year" },
        { value: "100%", label: "Human supervision" },
      ],
      footer:
        "In the event of any incident, response and alert protocols are triggered immediately. Our center operates 24 hours a day, 7 days a week, 365 days a year.",
    },
    sectors: {
      eyebrow: "Sectors we protect",
      title: "Solutions tailored to your industry",
      items: [
        "Industry & manufacturing",
        "Warehouses & logistics",
        "Retail & malls",
        "Corporate offices",
        "Sites & construction",
      ],
    },
    testimonials: {
      eyebrow: "What our clients say",
      title: "Trust built shift after shift",
      items: [
        {
          quote:
            "The monitoring center detected an intrusion attempt at dawn and acted within seconds. Zero losses. Impeccable service.",
          name: "Operations Manager",
          role: "Logistics company, Santiago",
        },
        {
          quote:
            "Having security and industrial cleaning with one provider simplified everything. Serious, uniformed, always supervised staff.",
          name: "Plant Manager",
          role: "Manufacturing industry",
        },
        {
          quote:
            "The guards are accredited and the supervision shows. They give us clear reports and immediate response to any event.",
          name: "Administrator",
          role: "Automotive dealership",
        },
      ],
    },
    faq: {
      eyebrow: "Frequently asked questions",
      title: "We answer your questions",
      items: [
        {
          q: "Are your guards OS-10 accredited?",
          a: "Yes. All our security personnel hold a valid OS-10 credential and receive continuous training in accordance with Chilean regulations.",
        },
        {
          q: "Do you serve companies across Chile?",
          a: "We operate mainly in the Metropolitan Region and coordinate services in other regions depending on the project. Ask us about your location.",
        },
        {
          q: "Can I hire security and industrial cleaning together?",
          a: "Yes. We are a group with three specialized companies, so you can hire security, monitoring technology and industrial cleaning in a single integrated contract.",
        },
        {
          q: "Does the monitoring center really operate 24/7?",
          a: "Yes. Human supervisors watch the cameras 24 hours a day, 7 days a week, 365 days a year, with motion detection, instant reports and immediate response protocols.",
        },
        {
          q: "How do I request a quote?",
          a: "Fill out the contact form, message us on WhatsApp or call us. We'll send a proposal tailored to your company at no cost.",
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Get a quote today",
      subtitle: "Tell us what you need to protect or keep clean",
      text: "We'll send a proposal tailored to your company. You can email us, message us on WhatsApp or call us directly.",
      formTitle: "Send us a message",
      fields: { name: "Name", phone: "Phone", email: "Email", message: "Message" },
      placeholders: {
        name: "Your name",
        phone: "+56 9 ...",
        email: "email@company.cl",
        message: "Tell us which service you need...",
      },
      submit: "Send request",
      sending: "Sending...",
      success: "Thank you! Your request was sent. We'll contact you shortly.",
      error: "An error occurred. Please try again or message us on WhatsApp.",
      validation: "Please complete at least your name and email.",
      contactLabels: { email: "Email", whatsapp: "WhatsApp", phone: "Phone" },
    },
    footer: {
      tagline: "Security, monitoring and industrial cleaning for companies in Chile.",
      servicesTitle: "Services",
      services: ["Security guards", "Access control", "CCTV cameras", "24/7 monitoring center", "Industrial cleaning"],
      companyTitle: "Grupo RPC",
      links: ["Services", "Companies", "Industrial cleaning", "Monitoring", "Contact"],
      contactTitle: "Contact",
      rights: "All rights reserved.",
    },
    whatsapp: "Need security? Message us",
  },
};
